import { render, staticRenderFns } from "./DomainLink.vue?vue&type=template&id=4fb77749&"
import script from "./DomainLink.vue?vue&type=script&lang=js&"
export * from "./DomainLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports